import React, { ReactElement } from "react";
import { Table } from "antd";
import { DirectoryNoStateMachineTableRecord } from "../../../redux/types/reportTypes";

export const columns = [
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Cluster Id",
    dataIndex: "cluster_id",
  },
  {
    title: "Ad Id",
    dataIndex: "ad_id",
  },
  {
    title: "Mp Url",
    dataIndex: "mp_url",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
  },
  {
    title: "Start Date",
    dataIndex: "start_date",
  },
  {
    title: "End Date",
    dataIndex: "end_date",
  },
  {
    title: "Hashed From",
    dataIndex: "hashed_from",
  },
];

type DirectoryNoStateMachineTableProps = {
  loading: boolean;
  records: Array<DirectoryNoStateMachineTableRecord>;
};

const DirectoryNoStateMachineTable = ({ loading, records }: DirectoryNoStateMachineTableProps): ReactElement => (
  <Table
    dataSource={records}
    columns={columns}
    loading={loading}
    rowKey="ad_id"
    pagination={false}
    scroll={{ y: 350, x: 3200 }}
  />
);

export default DirectoryNoStateMachineTable;
